/** Where the group's label sits relative to the panels. */
export enum SelectionPanelGroupLayoutStyle {
    /** Label above the panels (default). */
    Vertical = 'vertical',
    /** Label to the left of the panels, in a fixed-width column (see labelWidth). */
    Horizontal = 'horizontal',
}
